<div class="windows">
  <h1 i18n>{ code, plural, =0 {keep going} =1 {game over} =2 {new best : {{newBestScore}}} }</h1>

  <div class="windows__inside">

    <button mat-raised-button routerLink="../scores">
      <i class="material-icons-round">leaderboard</i>
    </button>

    <button mat-raised-button routerLink="../settings">
      <i class="material-icons-round">settings</i>
    </button>

    <button mat-raised-button (click)="restart()">
      <i class="material-icons-round">refresh</i>
    </button>
  </div>
</div>

<div class="background" (click)="hide()"></div>
